import Validates from './validates';
import Validate from './validate';

export { Validates, Validate };

